document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".firearm-options-container");
  if (!root || !window.nffi) return;

  const brandSelect = root.querySelector("#firearm-brand");
  const modelSelect = root.querySelector("#firearm-model");
  const holsterColorSelect = root.querySelector("#holster-color");
  const holstersContainer = root.querySelector("#holsters-container");
  const selectedHolsterIdInput = root.querySelector("#selected-holster-id");
  const selectedHolsterSKUInput = root.querySelector("#selected-holster-sku");
  
  // -----------------------------
  // Selected labels near dropdown title
  // -----------------------------
  function initDropdownSelectedLabels(scope = document) {
    const wraps = Array.from(scope.querySelectorAll(".firearm-dropdowns"));

    wraps.forEach((wrap) => {
      const label = wrap.querySelector(".dropdown-label");
      const select = wrap.querySelector("select.dropdown-select");
      if (!label || !select) return;

      // Save base label text once (without trailing ": ...")
      if (!label.dataset.baseText) {
        label.dataset.baseText = (label.textContent || "")
          .trim()
          .replace(/:.*$/, "");
      }

      const baseText = label.dataset.baseText;

      const update = () => {
        const opt = select.options?.[select.selectedIndex];
        const selectedText = (opt?.textContent || "").trim();

        const isPlaceholder =
          !select.value ||
          select.value === "" ||
          (opt && opt.disabled) ||
          /^select\b/i.test(selectedText);

        label.textContent = isPlaceholder ? baseText : `${baseText}: ${selectedText}`;
      };

      update();
      select.removeEventListener("change", update); // safety
      select.addEventListener("change", update);
    });
  }

  // Export for bag-options.js to call after show/hide
  window.NFFI_FirearmOptions = window.NFFI_FirearmOptions || {};
  window.NFFI_FirearmOptions.initDropdownSelectedLabels = initDropdownSelectedLabels;

  // -----------------------------
  // Load JSON data
  // -----------------------------
  Promise.all([
    fetch(window.nffi.firearmBrandsJsonUrl).then((res) => res.json()),
    fetch(window.nffi.firearmModelsJsonUrl).then((res) => res.json()),
  ])
    .then(([brands, models]) => {
      window.nffi.firearm_brands = brands;
      window.nffi.firearm_models = models;

      populateBrands();
      initDropdownSelectedLabels(root); // initial label state after options are ready
    })
    .catch((err) => {
      console.error("Failed to load firearm data:", err);
    });

  function populateBrands() {
    if (!brandSelect) return;

    const brandIdsWithModels = new Set(window.nffi.firearm_models.map((m) => m.BrandId));
    window.nffi.firearm_brands
      .filter((brand) => brandIdsWithModels.has(brand.Id))
      .forEach((brand) => {
        const option = document.createElement("option");
        option.value = brand.Id;
        option.textContent = brand.Name;
        brandSelect.appendChild(option);
      });

    initDropdownSelectedLabels(root);
  }

  function populateModels(brandId) {
    if (!modelSelect) return;

    modelSelect.innerHTML = '<option value="" disabled selected>Select Model</option>';

    const filtered = window.nffi.firearm_models.filter(
      (m) => m.BrandId.toString() === brandId.toString()
    );

    filtered.forEach((model) => {
      const option = document.createElement("option");
      option.value = model.SKU; // NOTE: SKU in value, text is Name
      option.textContent = model.Name;
      modelSelect.appendChild(option);
    });

    modelSelect.disabled = filtered.length === 0;
    initDropdownSelectedLabels(root);
  }

  // -----------------------------
  // Brand change
  // -----------------------------
  if (brandSelect) {
    brandSelect.addEventListener("change", function () {
      if (holsterColorSelect) holsterColorSelect.selectedIndex = 0;

      if (!this.value) {
        if (modelSelect) {
          modelSelect.disabled = true;
          modelSelect.innerHTML = '<option value="" disabled selected>Select Model</option>';
        }
        if (holstersContainer) holstersContainer.style.display = "none";
      } else {
        populateModels(this.value);

        if (holstersContainer && holsterColorSelect) {
          holsterColorSelect.disabled = true;
          holstersContainer.style.display = "none";
        }
      }

      initDropdownSelectedLabels(root);

      document.dispatchEvent(new CustomEvent("nffi:firearm-options:changed"));
    });
  }

  // -----------------------------
  // Model change
  // -----------------------------
  if (modelSelect && holsterColorSelect) {
    modelSelect.addEventListener("change", function () {
      const selectedModel = this.value;
      holsterColorSelect.disabled = !selectedModel;
      holsterColorSelect.selectedIndex = 0;

      initDropdownSelectedLabels(root);

      // Clear holster card on model change
      if (holstersContainer) {
        holstersContainer.innerHTML = "";
        holstersContainer.style.display = "none";
      }

      // Also clear hidden selected holster (prevents stale selection)
      if (selectedHolsterIdInput) selectedHolsterIdInput.value = "";
      if (selectedHolsterSKUInput) selectedHolsterSKUInput.value = "";

      // Trigger color change to refresh (keeps your behavior)
      holsterColorSelect.dispatchEvent(new Event("change"));

      document.dispatchEvent(new CustomEvent("nffi:firearm-options:changed"));
    });
  }

  // -----------------------------
  // Holster color change
  // -----------------------------
  if (holsterColorSelect && holstersContainer) {
    holsterColorSelect.addEventListener("change", function () {
      const selectedColor = this.value;
      holstersContainer.innerHTML = "";

      // Always update the label "Holster color: X"
      initDropdownSelectedLabels(root);

      if (!selectedColor) {
        holstersContainer.style.display = "none";
        if (selectedHolsterIdInput) selectedHolsterIdInput.value = "";
        if (selectedHolsterSKUInput) selectedHolsterSKUInput.value = "";        
        return;
      }

      const modelVal = modelSelect?.value || "";
      const isLightBearing = modelVal.includes("+");
      const selectedColorLower = selectedColor.toLowerCase().replaceAll(" ", "-");
      const desiredTag = isLightBearing ? "LIGHT BEARING" : "REGULAR";

      const holsters = window.nffi?.product_addons?.Holsters || [];
      const selectedHolster = holsters.find((h) => {
        const handleLower = (h.handle || "").toLowerCase();
        const tags = Array.isArray(h.tags)
          ? h.tags.map((t) => String(t).toUpperCase())
          : String(h.tags || "").toUpperCase();

        const matchesTag = tags.includes(desiredTag);
        const matchesColor = handleLower.includes(selectedColorLower);

        return matchesTag && matchesColor;
      });

      if (selectedHolster) {
        renderHolster(selectedHolster);
      } else {
        holstersContainer.style.display = "none";
      }

      if (selectedHolsterIdInput) {
        selectedHolsterIdInput.value = selectedHolster?.variants?.[0]?.id || "";
      }
      if (selectedHolsterSKUInput) {
        selectedHolsterSKUInput.value = selectedHolster?.variants?.[0]?.sku || "";
      }

      const holsterPriceInput = document.querySelector(".firearm-options-container #selected-holster-price-cents");
      if (holsterPriceInput) {
        holsterPriceInput.value = selectedHolster ? String(selectedHolster.price || 0) : "";
      }

      const selectedHolsterNameInput = root.querySelector(".firearm-options-container #selected-holster-name");
      if(selectedHolsterNameInput){
        selectedHolsterNameInput.value = selectedHolster ? selectedHolster.title : "";
      }
console.log('[selectedHolster]', selectedHolster);
      // notify other scripts that holster selection changed
      document.dispatchEvent(new CustomEvent("nffi:holster-selected", selectedHolster));

    });
  }

  function renderHolster(holster) {
    holstersContainer.innerHTML = "";

    const image = holster.images && holster.images.length > 0 ? holster.images[0] : "";

    const productCard = document.createElement("product-card");
    productCard.className = "product-card bg-custom text-custom";
    productCard.setAttribute(
      "style",
      "--background: 224 224 224; --text-color: 26 26 26; opacity: 1; transform: translateY(0px);"
    );

    productCard.innerHTML = `
      <div class="product-card__figure" data-country="USA">
        <img 
          src="${image}" 
          alt="${String(holster.title || "").toLowerCase()}" 
          width="2500" height="2500"
          class="product-card__image product-card__image--primary aspect-square"
          loading="lazy"
        >
      </div>
      <div class="product-card__info product-card__info--center">
        <div class="v-stack gap-0.5 w-full justify-items-center">
          <span class="product-card__title">${holster.title || ""}</span>
          <price-list class="price-list justify-center">
            <sale-price class="bcpo-cart-item-pricetext-subdued">
              <span class="sr-only">Sale price</span>$${(parseFloat(holster.price || 0) / 100).toFixed(2)}
            </sale-price>
          </price-list>
        </div>
      </div>
    `;

    holstersContainer.appendChild(productCard);
    holstersContainer.style.display = "block";
  }
});
